import { FormControl, Validators } from '@angular/forms';
import {
  EoCustomControlConfig,
  EoDropdownConfig,
  EoFormPanelConfig,
  EoInputConfig,
} from 'ngx-eo-web-components';

export const panel1 = new EoFormPanelConfig({
  name: 'form',
  panelContentStyleClass: 'grid',
  config: [
    new EoCustomControlConfig({
      name: 'clinicID',
      label: 'Κλινική',
      styleClass: 'col-6',
      control: new FormControl(null),
    }),
  ],
});

export const hospitalAvailabilitySearchFormConfig: EoFormPanelConfig[] = [
  panel1,
];


export const initSearchForm = (
  clinicId?: string | null,
  isClinicAdmin: boolean = false
): void => {
  initClinicDP(clinicId);
  handleClinicFc(clinicId, isClinicAdmin);
};

const setFc = (formGroupName: string, formControlName: string, value: any) => {
  hospitalAvailabilitySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.setValue(value);
};

function initClinicDP(clinicId: string | null | undefined) {
  setFc('form', 'clinicID', clinicId);
}

function handleClinicFc(
  clinicId: string | null | undefined,
  isClinicAdmin = false
) {
  if (clinicId && isClinicAdmin) {
    disableFc('form', 'clinicID');
  } else {
    enableFc('form', 'clinicID');
  }
}

const disableFc = (formGroupName: string, formControlName: string) => {
  hospitalAvailabilitySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.disable();
};

const enableFc = (formGroupName: string, formControlName: string) => {
  hospitalAvailabilitySearchFormConfig
    .find((cfc) => cfc.name === formGroupName)
    ?.config?.find((c) => c.name === formControlName)
    ?.control?.enable();
};
